import { render, staticRenderFns } from "./NavigationTips.vue?vue&type=template&id=67592f70&scoped=true"
import script from "./NavigationTips.vue?vue&type=script&lang=ts"
export * from "./NavigationTips.vue?vue&type=script&lang=ts"
import style0 from "./NavigationTips.vue?vue&type=style&index=0&id=67592f70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67592f70",
  null
  
)

export default component.exports